import React from "react";
import { useTheme } from "@carrier-io/air-react/styles";
import Grid from "@carrier-io/air-react/Grid";
import Link from "@carrier-io/air-react/Link";
import Typography from "@carrier-io/air-react/Typography";
import {
  clearLoginAttempts,
  deleteLookupsUserCookies,
} from "../../utils/cookie";
import { RoutesPage } from "../../constants/routes";
import { useNavigate, useSearchParams } from "react-router-dom";

type EmailChangeAccountProps = {
  email: string;
};

export const EmailChangeAccount = ({ email }: EmailChangeAccountProps) => {
  const [searchParams] = useSearchParams();
  const theme = useTheme();
  const redirectTo = searchParams.get("redirect_to");
  const navigate = useNavigate();

  const handleChangeAccount = () => {
    deleteLookupsUserCookies(window.location.hostname);
    clearLoginAttempts(window.location.hostname);
    navigate({
      pathname: RoutesPage.Login,
      search: `?redirect_to=${redirectTo}`,
    });
  };

  return (
    <Grid sx={{ alignSelf: "flex-start" }}>
      <Grid container direction={"column"} spacing={1}>
        <Grid>
          <Typography
            variant="body3"
            display="inline"
            color={theme.palette.text.secondary}
          >
            Email Address
          </Typography>
        </Grid>
        <Grid>
          <Typography variant="body1" display="inline">
            {email}
          </Typography>
        </Grid>
        <Grid>
          <Link
            variant="body2"
            component="button"
            data-testid="change-account"
            sx={{
              textDecoration: "none",
              fontWeight: 600,
            }}
            onClick={handleChangeAccount}
          >
            Change account
          </Link>
        </Grid>
      </Grid>
    </Grid>
  );
};
